import type { IFigureCollection } from '../models/IFigureCollection';
import type { IFigureDto } from '../models/IFigureDto';

export const AppEvent = {
  figureUpdated: 'figureUpdated',
  figureDataUpdated: 'figureDataUpdated',
  figureRemoved: 'figureRemoved',
  collectionCreated: 'collectionCreated',
  favoriteChanged: 'favoriteChanged',
} as const;

export type AppEventName = (typeof AppEvent)[keyof typeof AppEvent];

export type AppEventDetailMap = {
  figureUpdated: IFigureDto;
  figureDataUpdated: IFigureDto[];
  figureRemoved: { removedFigureId: number; collectionId: number };
  collectionCreated: IFigureCollection;
  favoriteChanged: { figureId: number; isFavorite: boolean };
};

export function emitAppEvent<K extends keyof AppEventDetailMap>(
  name: K,
  detail: AppEventDetailMap[K],
): void {
  window.dispatchEvent(
    new CustomEvent(name, {
      detail,
    }),
  );
}

